// FILECONTENT_START src/common/components/DataGrid/toolbar-buttons/DataGridToolbarCustomSettingsButton.tsx
import SettingsIcon from "@mui/icons-material/Settings";
import { Badge, Dialog, Tooltip } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import I18n from "i18n-js";
import { identity, pickBy } from "lodash";
import { ReactNode } from "react";
import { useLongPress } from "../../../modules/helpers";
import { useFilter } from "../../List";
import { DataGridToolbarProps } from "../DataGridToolbar";
import DataGridToolbarButtonContainer from "./DatagridToolbarButtonContainer";
import { RenderButtonProps } from "./DataGridToolbarCustomFilterButton";
export interface DataGridToolbarCustomSettingsButtonProps
  extends DataGridToolbarProps {
  icon?: ReactNode;
  tooltipText?: string;
  renderButton?: (props: RenderButtonProps) => JSX.Element;
}

export default function DataGridToolbarCustomSettingsButton({
  clearSearch,
  onChange,
  onCreate,
  load,
  value,
  apiRef,
  editUrl,
  canCreate,
  canBatchActions,
  canHandleTrash,
  deleteSelectedItems,
  restoreSelectedItems,
  headerItems = [],
  selectionState,
  trashType,
  setTrashType,
  extraHeaderItem,
  rowsState,
  buttonSize,
  loadOptions,
  renderSettings,
  applySettings,
  resetSettings,
  optionComponent,
  settings: filter,
  attributesNotCount,
  icon,
  tooltipText,
  renderButton,
}: DataGridToolbarCustomSettingsButtonProps) {
  const filterModal = useFilter<any, any>({
    attributesNotCount,
    filter,
    loadOptions: loadOptions
      ? () =>
          loadOptions({ cache: { ignoreCache: false } } as any, optionComponent)
      : undefined,
  });

  const longPressEvent = useLongPress(
    () => {
      if (filterModal.filterCount > 0) {
        resetSettings && resetSettings();
      }
    },
    () => {
      filterModal.setShowFilter(true);
    }
  );
  return (
    <>
      <DataGridToolbarButtonContainer>
        {renderButton ? (
          renderButton({ longPressEvent, filterModal, buttonSize, tooltipText })
        ) : (
          <Tooltip
            title={
              tooltipText
                ? tooltipText
                : `${I18n.t("App.settings")} (${I18n.t(
                    "App.longPressToClear"
                  )})`
            }
            color="info"
          >
            <IconButton
              color={filterModal.filterCount > 0 ? "primary" : undefined}
              {...longPressEvent}
            >
              <Badge badgeContent={filterModal.filterCount} color="primary">
                {!!icon ? icon : <SettingsIcon fontSize={buttonSize} />}
              </Badge>
            </IconButton>
          </Tooltip>
        )}
      </DataGridToolbarButtonContainer>
      {!!renderSettings && (
        <Dialog
          open={filterModal.showFilter}
          onClose={() => filterModal.setShowFilter(false)}
        >
          {renderSettings({
            ...filterModal,
            applyFilter: (item: any) =>
              applySettings && applySettings(pickBy(item, identity)),
            resetFilter: () => resetSettings && resetSettings(),
          })}
        </Dialog>
      )}
    </>
  );
}

// FILECONTENT_END src/common/components/DataGrid/toolbar-buttons/DataGridToolbarCustomSettingsButton.tsx